import s, { useRef as h, useState as C, useTransition as _, useEffect as x, useCallback as I, useMemo as y } from "react";
import { c as v } from "./app-a75c1d35.mjs";
import { B as u } from "./Block-9b78bd10.mjs";
import { B as E } from "./Button-c598cb52.mjs";
import "./Icon-3122c134.mjs";
import "./useClickOutside-726e7c36.mjs";
const w = "pagination", N = "pagination__items", S = "pagination__item", L = "pagination__item--selected", k = "pagination__caption", d = {
  pagination: w,
  paginationItems: N,
  paginationItem: S,
  paginationItemSelected: L,
  paginationCaption: k
};
function A(n) {
  const { value: t = 1, count: e, onChange: o } = n, a = h(null), [i, m] = C(P(t, e)), [, p] = _();
  x(() => m(P(t, e)), [t, e]);
  const c = I(
    (l) => {
      const r = typeof l == "number" ? l : l(i), g = P(r, e);
      g !== i && (m(g), o && p(() => o(g)));
    },
    [i, o, e]
  ), f = I(
    (l) => {
      switch (l.key) {
        case "ArrowRight":
          return a.current?.focus(), c((r) => r + 1);
        case "ArrowLeft":
          return a.current?.focus(), c((r) => r - 1);
      }
    },
    [c]
  ), b = y(() => D(i, e), [i, e]);
  return { page: i, handlePageChange: c, itemList: b, handleKeyDown: f, containerRef: a };
}
function P(n, t) {
  return Math.max(Math.min(n, t), 1);
}
function D(n, t, e = 1, o = 5) {
  const a = "...";
  return t === 1 ? [e] : t === 2 ? [e, t] : t <= o ? Array(t).fill(0).map((i, m) => m + 1) : n <= 2 ? [e, e + 1, e + 2, a, t] : n >= t - 1 ? [e, a, t - 2, t - 1, t] : [e, a, n, a, t];
}
function G(n) {
  const { i18n: t = {}, count: e, caption: o } = n, {
    btnNextText: a = "Next page",
    btnPrevText: i = "Previous page",
    btnPageText: m = "Go to page"
  } = t, { page: p, handlePageChange: c, itemList: f, handleKeyDown: b, containerRef: l } = A(n);
  return !e || e === 0 ? null : /* @__PURE__ */ s.createElement(u, { topPadding: u.Padding.NONE, bottomPadding: u.Padding.SMALL }, /* @__PURE__ */ s.createElement(u.Content, null, /* @__PURE__ */ s.createElement(
    "div",
    {
      className: d.pagination,
      "data-testid": "pagination",
      onKeyDown: b,
      tabIndex: -1,
      ref: l
    },
    /* @__PURE__ */ s.createElement(
      E.Arrow,
      {
        arrowDirection: "left",
        "data-testid": "pagination-prev",
        "aria-label": i,
        title: i,
        disabled: p === 1,
        onClick: () => c((r) => r - 1)
      }
    ),
    /* @__PURE__ */ s.createElement("ul", { className: d.paginationItems, "data-testid": "pagination-items" }, f.map((r, g) => /* @__PURE__ */ s.createElement("li", { key: g }, /* @__PURE__ */ s.createElement(
      R,
      {
        page: r,
        selectedPage: p,
        onSelect: c,
        title: m
      }
    )))),
    /* @__PURE__ */ s.createElement(
      E.Arrow,
      {
        arrowDirection: "right",
        "data-testid": "pagination-next",
        "aria-label": a,
        title: a,
        disabled: p === e,
        onClick: () => c((r) => r + 1)
      }
    )
  ), o && /* @__PURE__ */ s.createElement(
    "p",
    {
      className: d.paginationCaption,
      "data-testid": "pagination-caption"
    },
    o
  )));
}
function R({
  page: n,
  selectedPage: t,
  onSelect: e,
  title: o
}) {
  const a = typeof n == "number", i = a && n === t;
  return /* @__PURE__ */ s.createElement(
    "button",
    {
      type: "button",
      "data-testid": "pagination-item-" + n,
      "aria-current": i ? "page" : void 0,
      "aria-label": a ? `${o} ${n}` : void 0,
      className: v(
        d.paginationItem,
        i && d.paginationItemSelected
      ),
      disabled: !a,
      onClick: () => a && e?.(n),
      title: a ? `${o} ${n}` : void 0
    },
    n
  );
}
export {
  G as Pagination
};
//# sourceMappingURL=Pagination.js.map
